export const replaceUrl = (url: string) => url.replace(/[a-zA-Z0-9]{40}/, 'xx');

export const getRollbarUrl = () => {
  const url = window.location.origin;

  return `${url.replace('app', 'exceptions')}/`;
};
